import { filtersMutationKeys } from '../constants'
import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config.jsx'

export const useCreateFilterMutation = (options) => {
  const handleMutation = async ({ filter }) => {
    const config = {
      method: 'post',
      data: filter
    }

    const { data } = await api('/api/filters', config)

    return data
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: [filtersMutationKeys.CREATE_FILTER],
    ...options
  })
}
